import { DaexSytemErrorCode } from "../errors";

export interface userState {
  userData: UserDto;
  userAPIConnections: GetApiIntegrationDto[];
  isError: boolean;
  isSuccess: boolean;
  publicUser?: PublicUserDto;
  isLoading: boolean;
  errorCode?: DaexSytemErrorCode;
  message: string;
  searchResult?: PublicUserDto[];
}

export interface UserDto {
  email: string;
  firstName: string;
  lastName: string;
  phone?: string | null;
  profilePicture?: string | null;
  id?: string;
  token: string;
  googleCalendarConnection?: boolean;
  microsoftCalendarConnection?: boolean;
  membership?: string;
  isVerified: boolean;
  userName: string;
  activeRecordingId?: string | null;

  activeTask?: { id: string | null };
}

export interface PublicUserDto {
  firstName: string;
  lastName: string;
  profilePicture?: string | null;
  id: string;
  userName: string;
  email?: string;
}

export enum MemberStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  BLOCKED = "BLOCKED",
}

export interface PublicMemberDto extends PublicUserDto {
  role: UserRole;
  position?: UserRole;
  status?: MemberStatus;
}

export interface UpdateUserDto {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string | null;
  profilePicture?: string | null;
  id: string;
  newId?: string;
  userName?: string;
}

export interface ResetPasswordDto {
  resetToken: string;
  newPassword: string;
}

export interface DeleteAccountDto {
  deleteToken: string;
  email: string;
}

export type UserRole =
  | "OWNER"
  | "ADMIN"
  | "EDITOR"
  | "VIEWER"
  | "GUEST"
  | "PRIVATE";

export const USER_ROLES: UserRole[] = [
  "OWNER",
  "ADMIN",
  "EDITOR",
  "VIEWER",
  "GUEST",
  "PRIVATE",
];

export const SELECTABLE_USER_ROLES: UserRole[] = ["ADMIN", "EDITOR", "VIEWER"];

export interface GetApiIntegrationDto {
  id: string;
  provider: string;
  type: string;
  connectedEmail: string;
  scopes: string[];
  tokenExpiry: Date;
  status: IntegrationStatus;
  createdAt: Date;
  updatedAt: Date;
  metadata?: any;
}

export enum IntegrationStatus {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
  ERROR = "ERROR",
  DISCONNECTED = "DISCONNECTED",
}
